module.exports = __webpack_public_path__ + "media/images/badge__reviewed-100-6bd3f456b68fcc1e106d21ada6b0d453.svg";